import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearMappingBackUrl} from "../config/crystalclear-mapping-back-url";
import {SrcMappingAccountCode} from "../../model/mapping/src-mapping-account-code";
import {SrcMappingBrokerCode} from "../../model/mapping/src-mapping-broker-code";

@Injectable({
  providedIn: 'root'
})
export class MappingSrcMappingBrokerCodeService extends CommonCrudService<SrcMappingBrokerCode> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearMappingBackUrl.GET_MAPPING_SRCMAPPINGBROKERCODE_LIST,
      CrystalclearMappingBackUrl.SAVE_MAPPING_SRCMAPPINGBROKERCODE,
      CrystalclearMappingBackUrl.DELETE_MAPPING_SRCMAPPINGBROKERCODE);
  }

}
